import { Axios } from "../hooks/useAxiosInstance";

export const StaticText = (function () {

    // const { api_token } = useSelector(state => state.profile);

    const apis = () => ({
        fetch: async ({ api_token }) => await fetchRecord(api_token),
        updateText: async ({ data, api_token }) => await updateTextRecord(data, api_token),
        insertFaq: async ({ data, api_token }) => await insertFaqRecord(data, api_token),
        deleteFaq: async ({ data, api_token }) => await deleteFaqRecord(data, api_token),
        updateFaq: async ({ data, api_token }) => await updateFaqRecord(data, api_token)
    })

    async function fetchRecord(api_token) {
        const url = "api/admin/static-text";
        const option = {
            headers: {
                'Authorization': api_token,
                'Content-Type': 'application/json'
            }
        }

        return await Axios.get(url, option);
    }

    async function updateTextRecord(data, api_token) {
        const [key] = Object.keys(data);
        const url = `api/admin/static-text/${key}`;
        const option = {
            headers: {
                'Authorization': api_token,
                'Content-Type': 'application/json'
            }
        }

        return await Axios.patch(url, { data: data[key] }, option);
    }

    async function insertFaqRecord(data, api_token) {
        const url = `api/admin/static-text/faqs`;
        const option = {
            headers: {
                'Authorization': api_token,
                'Content-Type': 'application/json'
            }
        }

        return await Axios.post(url, data, option);
    }

    async function deleteFaqRecord(data, api_token) {
        const url = `api/admin/static-text/faqs/${data.faq_slug}`;
        const option = {
            headers: {
                'Authorization': api_token,
                'Content-Type': 'application/json'
            }
        }

        return await Axios.delete(url, option);
    }

    async function updateFaqRecord(data, api_token) {
        const url = `api/admin/static-text/faqs`;
        const option = {
            headers: {
                'Authorization': api_token,
                'Content-Type': 'application/json'
            }
        }

        return await Axios.patch(url,data, option);
    }


    return apis();

})()
